import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=f4391f46&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4391f46')) {
      api.createRecord('f4391f46', component.options)
    } else {
      api.reload('f4391f46', component.options)
    }
    module.hot.accept("./PrivacyPolicyView.vue?vue&type=template&id=f4391f46&", function () {
      api.rerender('f4391f46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/PrivacyPolicyView.vue"
export default component.exports